<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>查看大图</title>
    <desc>Created with Sketch.</desc>
    <g id="配件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="1-3-配件搜索有结果"
        transform="translate(-559.000000, -371.000000)"
      >
        <g id="查看大图" transform="translate(559.000000, 371.000000)">
          <g>
            <rect
              id="矩形备份-18"
              fill="currentColor"
              opacity="0.8"
              transform="translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
              x="0"
              y="0"
              width="16"
              height="16"
              rx="8"
            ></rect>
            <path
              d="M12.6660308,12.1433304 L11.5390536,10.8879754 L11.5390535,10.8879755 C13.2685224,8.91071967 13.067656,5.9058211 11.0904003,4.17635223 C9.11314447,2.44688336 6.1082459,2.64774972 4.37877703,4.6250055 C2.64930816,6.60226129 2.85017452,9.60715986 4.82743031,11.3366287 C6.50849779,12.8070254 8.9861998,12.9097753 10.7832371,11.5836036 L11.901855,12.8295243 L11.901855,12.8295243 C12.0913417,13.0405785 12.4160454,13.0580618 12.6270995,12.868575 C12.8381537,12.6790883 12.855637,12.3543846 12.6661502,12.1433305 C12.6661502,12.1433305 12.6661502,12.1433305 12.6661502,12.1433305 L12.6660308,12.1433304 Z M7.96286814,11.4833034 L7.96286813,11.4833034 C5.90508667,11.4833034 4.23698832,9.8150601 4.23698832,7.75729058 C4.23698832,5.69950912 5.90521803,4.03141077 7.96298755,4.03141077 C10.020769,4.03141077 11.6888674,5.69964048 11.6888674,7.75741 C11.6888674,8.74558409 11.2962859,9.69327442 10.5975325,10.3920194 L10.5975324,10.3920196 C9.90026936,11.093005 8.9515747,11.4859507 7.96286321,11.4833034 L7.96286814,11.4833034 Z M10.0878479,7.23297207 L8.46813898,7.23297207 L8.46813898,5.61326317 L8.46813898,5.61326317 C8.46813898,5.32965946 8.23823179,5.09975227 7.95462809,5.09975227 C7.67102438,5.09975227 7.44111719,5.32965946 7.44111719,5.61326317 L7.44111719,7.23297207 L5.79752406,7.23297207 L5.79752408,7.23297207 C5.51392037,7.23297205 5.28401319,7.46287926 5.28401319,7.74648297 C5.28401319,8.03008667 5.51392037,8.25999386 5.79752408,8.25999386 C5.79752409,8.25999386 5.79752411,8.25999386 5.79752412,8.25999386 L7.44111725,8.25999386 L7.44111725,9.91564852 L7.44111725,9.9156486 C7.44111729,10.1992523 7.67102443,10.4291595 7.95462814,10.4291595 C8.23823185,10.4291595 8.46813904,10.1992523 8.46813904,9.9156486 L8.46813904,8.25999394 L10.0878479,8.25999394 L10.0878479,8.25999394 C10.3714516,8.25999395 10.6013588,8.03008675 10.6013588,7.74648304 C10.6013588,7.46287933 10.3714516,7.23297215 10.0878479,7.23297215 L10.0878479,7.23297207 Z"
              id="形状"
              fill="#FFFFFF"
              fill-rule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Enlarge'
});
</script>
